import { LOAD_ACCOUNTS_SUCCESS, LOAD_ACCOUNTS_FAILED, UPDATE_CURRENT_ACCOUNT, PAID_ACCCOUNT, IS_IE } from "./actionType";
import { enableLoader, disableLoader, disableLoaderWithError } from "./uiActions";
import axios from "axios";

//let ONEINC_VALUE, ONEINC_GETACTIVEPOLICIES_URL;

//let ACCOUNTS_URL;
let AZURE_URL,AIS_KEY,AIS_AZURE_GETACTIVEPOLICIES_URL;
if (sessionStorage.getItem('app_info')) {
	//ACCOUNTS_URL = JSON.parse(sessionStorage.getItem('app_info')).ACCOUNTS_URL;
	AZURE_URL = JSON.parse(sessionStorage.getItem('app_info')).AIS_AZURE_URL;
	AIS_KEY = JSON.parse(sessionStorage.getItem('app_info')).AIS_KEY;
	AIS_AZURE_GETACTIVEPOLICIES_URL = JSON.parse(sessionStorage.getItem('app_info')).AIS_AZURE_GETACTIVEPOLICIES_URL;
	//ONEINC_VALUE = JSON.parse(sessionStorage.getItem('app_info')).ONEINC_VALUE;
	//ONEINC_GETACTIVEPOLICIES_URL = JSON.parse(sessionStorage.getItem('app_info')).ONEINC_GETACTIVEPOLICIES_URL;
}

function getURL(accountNumber, zip, cCode, uCode, timeStamp) {
	return (
		`${AZURE_URL}?billing_account_number=${accountNumber.replace(" ", "")}&billing_zipcode=${zip}&cCode=${cCode}&uCode=${uCode}&timeStamp=${timeStamp}`
	);
}

export const clearUserData = () => {
	return { type: PAID_ACCCOUNT };
}

export const loadAccountsSuccess = (accounts, pcgx) => {
	return { type: LOAD_ACCOUNTS_SUCCESS, accounts, pcgx };
}
export const loadAccountsFailed = errorInfo => {
	return { type: LOAD_ACCOUNTS_FAILED, errorInfo };
}

export const updateAccountPayment = (accountUpdate) => {
	return { type: UPDATE_CURRENT_ACCOUNT, accountUpdate };
}

export const isIEFlag = (isIEFlag) => {
	return { type: IS_IE, isIEFlag }
}

const fetchPolicyDetails = async (accountNumber) => {
	try {
		const accountId = accountNumber.substring(0, 10).replace(" ", "");
		const policiesResponse = await axios.get(
			`${AIS_AZURE_GETACTIVEPOLICIES_URL}/${accountId}/policies`,
			{ headers: { 'Ocp-Apim-Subscription-Key': AIS_KEY } }
		);
		return policiesResponse.data;
	}
	catch (error) {
		console.error("Error fetching policy details:", error);
		return null;
	}
}

export const loadAccounts = (accountNumber, zip, cCode, uCode, timeStamp, history, pcgx) => {
	return async dispatch => {

		// Helper to build term string from effective and expiration dates
		const buildPolicyTerm = (effectiveDate, expirationDate) => {
			if (!effectiveDate || !expirationDate) return null;
			const effectiveYear = new Date(effectiveDate).getFullYear();
			const expirationYear = new Date(expirationDate).getFullYear();
			return `${effectiveYear}-${expirationYear}`;
		};

		// Add term field to every policy in every account
		const addTermToPolicies = (accounts) => {
			return accounts.map(account => ({
				...account,
				policies: account.policies.map(policy => ({
					...policy,
					term: buildPolicyTerm(policy.policy_effective, policy.policy_expiration)
				}))
			}));
		};

		dispatch(enableLoader());

		try {
			const [policiesData, res] = await Promise.all([
				fetchPolicyDetails(accountNumber),
				axios.get(
					getURL(accountNumber, zip, cCode, uCode, timeStamp),
					{
						headers: {
							"Ocp-Apim-Subscription-Key": AIS_KEY,
						},
					}
				),
			]);

			const policiesArray = Array.isArray(policiesData)
				? policiesData
				: (policiesData && policiesData.Policies ? policiesData.Policies : []);

			console.log("policiesArray extracted:", policiesArray);
			console.log("billing API accounts:", res.data.accounts);

			if (policiesArray.length > 0 && res.data.accounts && res.data.accounts.length > 0) {
				const policyAccountNumbers = new Set(
					policiesArray.map(policy => policy.PolicyNumber)
				);

				res.data.accounts = res.data.accounts.filter(account =>
					(policyAccountNumbers.has(account.account_number))
				);
				res.data.accounts.forEach(account => {
					if (account.source_type === "CIP") {
						account.policies = [];
					}
				});
			} else {
				console.warn("Skipping filter — policiesArray empty or no accounts in billing response", {
					policiesArray,
					accounts: res.data.accounts
				});
			}

			if (res.data.CaptchaMatch === false) {
				dispatch(disableLoaderWithError());
				dispatch(loadAccountsFailed({
					"code": "401",
					"message": "You have entered incorrect captcha! Please try again!!"
				}));
			}
			else if (res.data.CaptchaTimeMatch === false) {
				dispatch(disableLoaderWithError());
				dispatch(loadAccountsFailed({
					"code": "402",
					"message": "Captcha has expired! Please Refresh the page & try again."
				}));
			}
			else if (res.data.accounts.length === 0) {
				dispatch(disableLoaderWithError());
				dispatch(loadAccountsFailed({
					"code": "404",
					"message": "We can't find that billing account and/or zip code, please try again with a valid combination or use the \"?\" Tool Tip to see where the Billing number is on your printed invoice."
				}));
			}
			else {
				// ✅ Add term field to every policy before sending to reducer
				const accountsWithTerm = addTermToPolicies(res.data.accounts);
				res.data.accounts = accountsWithTerm;

				dispatch(disableLoader());
				dispatch(loadAccountsSuccess(res.data, pcgx ? true : false));
				history.push("/accounts");
			}
		} catch (error) {
			dispatch(disableLoaderWithError());
			if (error.response) {
				dispatch(loadAccountsFailed({
					"code": error.response.status,
					"message": error.response.data.message
				}));
				history.push('/error');
			} else if (error.request) {
				dispatch(loadAccountsFailed({
					"code": "N404",
					"message": "Network Error"
				}));
				history.push('/error');
			} else {
				dispatch(loadAccountsFailed({
					"code": "E405",
					"message": "We are experiencing some technical issues."
				}));
				history.push('/error');
			}
		}
	}
}




// WEBPACK FOOTER //
// ./src/actions/accountActions.js